var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isPlaceholder)?_c('div',{staticClass:"cultivation-container"},[_c('div',{staticClass:"color-container",style:({backgroundColor: _vm.color})}),_vm._v("\n  "+_vm._s(_vm.label)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }